import React, {useEffect, useState} from 'react';
import {
    fetchProductsSummaryPages, fetchProductsSummaryPByCategoryID
} from "../../../reduxLib/productLib";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import Categories from "../Categories/categories";
import ProductCardShort from "./ProductElements/productCardShort";



function ProductExplorer(props) {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [selectedProductId, setSelectedProductId] = useState(null);
    const [selectedCategorylist, setSelectedCategorylist] = useState(0);
    const [productSummaryPage,setProductsSummaryPage]=useState([]);
    const [productSummary,setProductsSummary]=useState([]);
    const productSummaryL= useSelector((state)=> state.productreducer.productSymmaryListpage);
    const productSummaryAL= useSelector((state)=> state.productreducer.productSummaryList);
    const productSymmaryListpageCatID=useSelector((state)=> state.productreducer.productSymmaryListpageCatID);
    const state=useSelector((state)=> state.productreducer.state);
    const catSelected = useSelector(state => state.productreducer.productSymmaryListpageCatID_selected);
    const pagesize=20;
    const page=props.page;
    const onBreadcrumbChange=props.onBreadcrumbChange;
    const categoryId=props.categoryId;
    const productListSize=productSummaryL.length;



    useEffect(() => {


        if (selectedCategorylist === 0) {
                //let pages=Math.ceil(productSummaryAL.length/pagesize);
            if (!productSummaryL || productSummaryL.length === 0 ) {
                //dispatch(fetchProductsByCategory(selectedCategorylist));

                dispatch(fetchProductsSummaryPages({pagenumber: page, pagesize: pagesize})).then((action) => {
                    // Once the action is fulfilled, set the eventprofile state
                    if (action.payload) {
                        setProductsSummaryPage(action.payload);
                        console.log("playload ", action.payload);
                        console.log("playload E", productSummaryPage);
                    }
                });
            }
            else
            {
                setProductsSummaryPage(productSummaryL);
                console.log("not disp ", productSummaryPage);
            }
        }
        else if (catSelected !== selectedCategorylist)
        {
                    dispatch(fetchProductsSummaryPByCategoryID({
                        catid: selectedCategorylist,
                        pagenumber: page,
                        pagesize: pagesize
                    })).then((action) => {
                        // Once the action is fulfilled, set the eventprofile state

                        if (action.payload) {
                            setProductsSummaryPage(action.payload);
                            console.log("playload ", action.payload);
                            console.log("playload E", productSummaryPage);
                        }
                    });
        }
        else {
            // ίδια κατηγορία -> πάρε cached
            setProductsSummaryPage(productSymmaryListpageCatID);
        }
    }, [dispatch, selectedCategorylist, catSelected, productSummaryL, productSymmaryListpageCatID]);

    return (
        <div className="font-script">


                <section id="category-hero" className="bg-cream py-12">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="text-center mb-8">
                            <h1 className="text-5xl font-serif font-bold text-brand-green mb-4">Our Basket
                                Collection</h1>
                            <p className="text-gray-600 text-lg max-w-2xl mx-auto">Discover our handcrafted wicker
                                baskets, made with traditional techniques and natural materials</p>
                        </div>
                    </div>
                </section>

                <section id="filters-section" className="py-8 bg-white border-b">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
                            <div className="w-full lg:w-auto">
                                <h3 className="text-sm font-semibold text-gray-700 mb-3">Categories</h3>
                                <Categories {...{categoryId,onBreadcrumbChange}} onCategoryChange={setSelectedCategorylist} />
                            </div>

                            <div className="w-full lg:w-auto flex items-center gap-4">
                                <div className="relative flex-1 lg:flex-none lg:w-80">

                                </div>

                            </div>
                        </div>
                    </div>
                </section>

                <section id="products-grid" className="py-12">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="flex justify-between items-center mb-6">
                            <p className="text-gray-600">Showing <span className="font-semibold">{productSummaryPage.length}</span> products</p>
                            <div className="flex gap-2">
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-8">
                            {
                                productSummaryPage?.map((product,index) => (
                                    <ProductCardShort  key={product.productID}
                                                       {...{
                                                           productID: product.productID,
                                                           name: product.name,
                                                           description: product.description,
                                                           price: product.price,
                                                           rating: product.rating,
                                                           categoryRelId: product.categoryRelId,
                                                           image: product.imageURL,
                                                       }}/>
                                ))
                            }
                        </div>


                    </div>
                </section>
        </div>
    );

}

export default ProductExplorer;